
<template>
	<c-dialog ref="dialog" title="添加任务" width="100vw-300" height="700" enable-flex @resolve="resolve">
		<!--工序、工艺路线切换选择-->
		<c-tab-list ref="tabList" :tabs="tabList" :immediate="true" @change="tabHandle"></c-tab-list>
		
		<view-list v-show="currentTab==1" class="flex-grow" work-type="9" view-id="10008" ref="view" selector :selected-field="{name: 'process_name'}">
			<template #search>
				<m-search ref="search" column="4">
					<m-search-item label="工艺编号">
						<c-input name="process_code"></c-input>
					</m-search-item>
					<m-search-item label="工艺名称">
						<c-input name="process_name"></c-input>
					</m-search-item>
					<m-search-item label="加工类型">
						<c-select name="process_type" :options="processTypeDic"></c-select>
					</m-search-item>
					<m-search-item label="检验方式">
						<c-select name="test_mode" :options="testModeDic"></c-select>
					</m-search-item>
					<m-search-item label="自动出库">
						<c-select name="material_auto_out" :options="openCloseDic"></c-select>
					</m-search-item>
					<m-search-item label="自动入库">
						<c-select name="product_auto_in" :options="openCloseDic"></c-select>
					</m-search-item>
					<m-search-item label="报工前打卡">
						<c-select name="output_start" :options="openCloseDic"></c-select>
					</m-search-item>
				</m-search>
			</template>
			
			<template #operate>
				<c-button color="main" v-if="auth('b_process_edit')" v-lock="lock('b_process_edit')" prepend-icon="tf-add" @click="globalDialog('processEdit', $refs.view.update)">创建工序</c-button>
			</template>
		
			<template #output_auth_names="{data}">
				<c-tags v-if="!data.output_auth_names" value="所有用户"></c-tags>
				<c-tags v-else :value="data.output_auth_names"></c-tags>
			</template>
			
			<template #defects_names="{data}">
				<span v-if="!data.defects_names">-</span>
				<c-tags v-else :value="data.defects_names"></c-tags>
			</template>
			
			<template #material_auto_out="{data}">
				<c-state dict="openCloseDic" :value="data.material_auto_out"></c-state>
			</template>
			
			<template #product_auto_in="{data}">
				<c-state dict="openCloseDic" :value="data.product_auto_in"></c-state>
			</template>
			
			<template #process_type="{data}">
				<c-state dict="processTypeDic" :value="data.process_type"></c-state>
			</template>
			
			<template #test_mode="{data}">
				<c-state dict="testModeDic" :value="data.test_mode"></c-state>
			</template>
			
			<template #output_start="{data}">
				<c-state dict="openCloseDic" :value="data.output_start"></c-state>
			</template>
		</view-list>
		
		<div v-show="currentTab==2" class="flex-grow flex-column">
			<m-search ref="search" column="4" @search="searchHandle">
				<m-search-item label="工艺路线编号">
					<c-input name="route_code"></c-input>
				</m-search-item>
				<m-search-item label="工艺路线名称">
					<c-input name="route_name"></c-input>
				</m-search-item>
				<m-search-item label="备注">
					<c-input name="remark"></c-input>
				</m-search-item>
			</m-search>
		
			<m-operate>
				<c-button color="main" v-if="auth('b_processroute_edit')" v-lock="lock('b_processroute_edit')" prepend-icon="tf-add" @click="globalDialog('processRouteEdit', $refs.list.update)">创建工艺路线</c-button>
			</m-operate>
		
			<c-table ref="list" height="grow">
				<c-table-column type="selector"  width="32"></c-table-column>
				<c-table-column label="工艺路线编号" name="route_code" width="150"></c-table-column>
				<c-table-column label="工艺路线名称" name="route_name" width="200"></c-table-column>
				<c-table-column label="包含工序列表" name="process_names" width="250">
					<template #default="{data}">
						<span v-if="!data.process_names">-</span>
						<c-tags v-else :value="data.process_names"></c-tags>
					</template>
				</c-table-column>
				<c-table-column label="备注" name="remark" width="200"></c-table-column>
				<c-table-column label="创建人" name="create_user_realname" width="120"></c-table-column>
				<c-table-column label="创建时间" name="create_date" width="140"></c-table-column>
			</c-table>
		</div>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
	    name: 'processSelector',
		
		data() {
			return {
				tabList: [{
					name: '选择工序',
					value: 1
				}, {
					name: '选择工艺路线',
					value: 2
				}],
				currentTab: 1
			}
		},
		
		computed: {
			...mapState(['openCloseDic','processTypeDic','testModeDic'])
		},
		
		methods: {
			open() {
				this.$refs.tabList.changeIndex(0);
				this.$refs.view.reset();
				this.$refs.search.clear();
				this.searchHandle();
				this.$refs.dialog.open();
			},
			
			/********切换Tab***********/
			tabHandle(tab) {
				this.currentTab = tab.value;
			},
			
			/********搜索************/
			searchHandle(data) {
				this.$refs.list.load({
					url: '/process/route/list',
					data
				});
			},
			 
			resolve(stop) {
				//选择的是工序
				if(this.currentTab == 1){
					var data = this.$refs.view.selectedData;
					if (!data.length) {
						stop();
						this.$message({
							message: '请选择工序'
						});
						return;
					}
					this.$emit('resolve', data);
				//选择的是工艺路线
				}else if(this.currentTab == 2){
					var selectedRows = this.$refs.list.getRow('selected');
					if (!selectedRows.length) {
						stop();
						this.$message({
							message: '请选择工艺路线'
						});
						return;
					}
					
					if (selectedRows && selectedRows.length > 0){
						var ids = [];//选中的数据行
						if (selectedRows && selectedRows.length > 0){
							ids = selectedRows.map(item => item.data.id);
						}
						this.request({
							url:'/process/route/processlist',
							data: {
								ids: ids
							},
							loading: false,
							success: data => {
								this.$emit('resolve', data);
							}
						});
					}
					
					
				}
			}
		}
	}
</script>